import { ALIGNMENT_AXES, alignmentBand, type AlignmentSnapshot } from '@mlm/shared/coaching';
import { Meter } from './primitives';

/**
 * The four daily axes (blueprint SC-27), in one place so the Align hub, the
 * guidance panel and Home always name and word them the same way. The caller
 * owns the layout around them; this only decides the list and the band words.
 */
export function AlignmentMeters({ alignment }: { alignment: AlignmentSnapshot }) {
  return (
    <>
      {ALIGNMENT_AXES.map(({ key, label }) => (
        <Meter
          key={key}
          label={label}
          value={alignment[key]}
          note={alignmentBand(alignment[key])}
        />
      ))}
    </>
  );
}
